export default "__VITE_ASSET__ChN93hDY__"